import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { map, retry, shareReplay } from 'rxjs/operators'
import { environment } from '../../environments/environment'
import { FuseqHeaders } from './fuseq.headers'
import { Router } from '@angular/router'
import { MessageService } from '@openng/optimus-ui/api'
import { AuthenticationApiService } from '../_services'
import { FuseqSessionService } from './session.service'
import { FuseqRaidenService } from './fuseq-raiden/fuseqRaiden.service'
import { sanitizeReturnUrl } from './fuseq.utils'
@Injectable({
  providedIn: 'root'
})
export class FuseqAuthService {
  // private currentUserSubject: BehaviorSubject<any>;
  // public currentUser: Observable<any>;
  constructor (
    private readonly fuseqHeaders: FuseqHeaders,
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly messageService: MessageService,
    private readonly apiService: AuthenticationApiService,
    private readonly fuseqRaiden: FuseqRaidenService,
    private fuseqUser: FuseqSessionService
  ) {
    // this.currentUserSubject = new BehaviorSubject<any>(this.getUser());
    // this.currentUser = this.currentUserSubject.asObservable();
  }

  /* public get currentUserValue(): any {
      return this.currentUserSubject.value;
  } */
  async logout (type = null, returnUrl: string | null = null) {
    const safeReturnUrl = sanitizeReturnUrl(returnUrl)
    if (type === 'external') {
      this.removeUser()
      this.messageService.add({ severity: 'warn', detail: 'Please Login' })
      window.location.href = window.location.origin + '/login'
      await this.router.navigate(['/login'], { queryParams: safeReturnUrl ? { returnUrl: safeReturnUrl } : {} }).finally(() => {})
    }
    if (type === 'session') {
      this.removeUser()
      this.messageService.add({ severity: 'warn', summary: 'Login to continue', detail: 'Session Expired' })
      await this.router.navigate(['/login'], { queryParams: safeReturnUrl ? { returnUrl: safeReturnUrl } : {} }).finally(() => {})
    }
    if (type == null) {
      try {
        this.apiService.logout().subscribe(async (data) => {
          this.removeUser()
          this.messageService.add({ severity: 'success', detail: 'Success Logout' })
          await this.router.navigate(['/login']).finally(() => {})
        }, async (error) => {
          this.removeUser()
          console.log(error)
          this.messageService.add({ severity: 'success', detail: 'Success Logout' })
          await this.router.navigate(['/login']).finally(() => {})
        })
      } catch (e) {
        this.messageService.add({ severity: 'error', detail: String(e) })
      }
    }
  }

  removeUser () {
    this.fuseqUser.session = null
    this.fuseqRaiden.raidenSession = null
    // return sessionStorage.removeItem('currentUser');
  }

  getUser () {
    const currentUser = this.fuseqUser.session
    return currentUser ? this.fuseqUser.session : this.logout('external')
  }

  /// //////////////////////////////////////////
  login (username: string, password: string): Observable<any> {
    this.removeUser()
    const loginEndPoint = `${environment.API_URL}/login?username=${username}&password=${password}`
    return this.http.get<any>(loginEndPoint, this.fuseqHeaders.setHeaders('GET'))
      .pipe(retry(2), map(user => {
        if (!!user && user.token) {
          user.last_action = Date.now()
          // sessionStorage.setItem('currentUser', JSON.stringify(user));
          // this.currentUserSubject.next(user);
          this.fuseqUser.session = user
        }
        return user
      }),
      // catchError(() => {
      //   return EMPTY
      // }),
      shareReplay()
      )
  }

  /* updateCurrentUser(key, value) {
        const updatedUser = {...this.currentUserValue, [key]: value};
        sessionStorage.setItem(key, JSON.stringify(value));
        this.currentUserSubject.next(updatedUser);
    } */

  isLoggedIn (): boolean {
    return !!this.getUser()
  }

  checkSession () { // temporary function while implementing logout on 401 error //remove in app.component.ts
    const user = this.fuseqUser.session
    if (user) {
      const lastAction = user.last_action
      if ((Date.now() - lastAction) <= 1800000) {
        const newAction = Date.now()
        user.last_action = newAction
        this.fuseqUser.session = user
        return true
      }
    }
    this.logout()
    this.router.navigate(['/login']).finally(() => {})
    return false
  }

  checkLogin (): Observable<any> {
    return this.http.get<any>(`${environment.API_URL}/Data/GetHeaders`,
      this.fuseqHeaders.setTokenHeaders('GET')).pipe(retry(2), map(user => {
      if (!!user && user.token) {
        user.last_action = Date.now()
        // sessionStorage.setItem('currentUser', JSON.stringify(user));
        // this.currentUserSubject.next(user);
        this.fuseqUser.session = user
      }
      return user
    }),
    shareReplay()
    )
  }

  checkToken () {
    this.checkLogin().subscribe((data: any) => {
    }, error => {
      this.logout()
      console.log(error)
      this.router.navigate(['/login']).finally(() => {})
      return false
    })
  }

  getUserPermissions () {
    const loggedInUser = this.fuseqUser.session
    let permissionsArray = []
    if (loggedInUser) {
      permissionsArray = loggedInUser.permissions
    }
    return permissionsArray
  }

  checkIfPermissionKeyExists (key: string): boolean {
    let permission = false
    const userPermissions = this.getUserPermissions()
    if (userPermissions?.length > 0) {
      const formPermission = userPermissions.find(_permission => _permission === key)
      permission = !!formPermission
    }
    return permission
  }

  async genRandomPSW (numbers = 2, lowers = 3, uppers = 3, symbols = 2) {
    const promise = new Promise((resolve) => {
      const lowersList = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', /* 'l', */ 'm', 'n', /* 'o', */ 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
      const uppersList = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', /* 'I', */ 'J', 'K', 'L', 'M', 'N', /* 'O', */ 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
      const numbersList = [/* '0', */'1', '2', '3', '4', '5', '6', '7', '8', '9']
      const symbolsList = ['!', '?', '@', '$', '%', '^', '&', '*', '(', ')', '+', '_']
      const getRandom = (array) => array[Math.floor(Math.random() * array.length)]
      let finalCharacters = ''
      for (let i = 0; i < numbers; i++) {
        finalCharacters = finalCharacters.concat(getRandom(numbersList))
      }
      for (let i = 0; i < lowers; i++) {
        finalCharacters = finalCharacters.concat(getRandom(lowersList))
      }
      for (let i = 0; i < symbols; i++) {
        finalCharacters = finalCharacters.concat(getRandom(symbolsList))
      }
      for (let i = 0; i < uppers; i++) {
        finalCharacters = finalCharacters.concat(getRandom(uppersList))
      }
      const pass = finalCharacters.split('').sort(() => 0.5 - Math.random()).join('')
      console.log(pass)
      resolve(pass)
    })
    const pass = await promise
    return pass
  };

  async checkPSWStrength (password, username, minNumbers = 1, minLowers = 1, minUppers = 1, minSymbols = 1, minLength = 10) {
    const promise = new Promise((resolve, reject) => {
      const lowersList = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
      const uppersList = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
      const numbersList = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
      const symbolsList = ['!', '?', '@', '$', '%', '^', '&', '*', '(', ')', '+', '_']
      const resume = {
        lowers: 0,
        uppers: 0,
        numbers: 0,
        symbols: 0
      }
      if (password != null && password.length >= minLength) {
        password.split('').forEach((x) => {
          if (lowersList.includes(x)) {
            resume.lowers++
          }
          if (uppersList.includes(x)) {
            resume.uppers++
          }
          if (numbersList.includes(x)) {
            resume.numbers++
          }
          if (symbolsList.includes(x)) {
            resume.symbols++
          }
        })
        if (resume.lowers < minLowers) {
          reject('Lower characters required: ' + minLowers)
        } else if (resume.uppers < minUppers) {
          reject('Upper characters required: ' + minUppers)
        } else if (resume.numbers < minNumbers) {
          reject('Numbers required: ' + minNumbers)
        } else if (resume.symbols < minSymbols) {
          reject('Symbols required: ' + minSymbols + ' - Symbols allowed: ' + symbolsList.join(' '))
        } else if (password.toLowerCase().includes(username.toLowerCase())) {
          reject('Password cannot contains Username')
        } else {
          resolve('Password strong')
        }
      } else {
        reject('Password too short')
      }
    })
    const pass = await promise
    return pass
  };
}
